import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useEffect } from "react";
import type { ReactNode } from "react";

import { setAccessToken } from "@src/auth/tokenStore";

/**
 * Invisible component that synchronizes the Kinde access token into
 * the global token store. Place this inside the KindeProvider subtree.
 */
export const TokenSync = ({ children }: { readonly children: ReactNode }): ReactNode => {
  const { getToken } = useKindeAuth();

  useEffect(() => {
    let cancelled = false;
    const sync = async (): Promise<void> => {
      try {
        const token = await getToken();
        if (!cancelled) setAccessToken(token ?? null);
      } catch {
        if (!cancelled) setAccessToken(null);
      }
    };
    void sync();

    // Refresh token periodically (every 30s) to handle expiry
    const interval = setInterval(() => void sync(), 30_000);
    return () => {
      cancelled = true;
      clearInterval(interval);
      setAccessToken(null);
    };
  }, [getToken]);

  return <>{children}</>;
};
